import axios from "axios";
import Swal from "sweetalert2";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add the auth token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Function to set the auth token on the instance
const setAuthToken = (token) => {
  if (token) {
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common["Authorization"];
  }
};

// Response Interceptor to handle token expiration and other auth errors
axiosInstance.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response.data;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (error.response) {
      const { status } = error.response;

      if (status === 401) {
        // Token is invalid or expired
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        setAuthToken(null); // Clear auth token from default headers
        // Redirect to login page
        // Use window.location to force a full page refresh which will reset all state.
        if (window.location.pathname !== "/login") {
          Swal.fire({
            title: "Lỗi!",
            text: "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
            icon: "error",
          }).then(() => {
            window.location.href = "/login";
          });
        }
      } else if (status === 403) {
        // Forbidden - User does not have permission
        Swal.fire(
          "Thất bại!",
          "Bạn không có quyền thực hiện thao tác này.",
          "error"
        );
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
